import React, { useState } from 'react'

// includes
import NotificationItem from './includes/NotificationItem'
import CopyOfCustomerNotifications from './includes/CopyOfCustomerNotifications'
import AdminEmailAddresses from './includes/AdminEmailAddresses'
import SkeletonLoading from '../../Notifications__loadingSkeleton'

export default function AdminOrderNotifications(props) {

    // props
    const {
        notificationsData,
        setNotificationsData,

        loading,
        loadingCount,

        notificationsList,

        handleNotificationClick,
        handleNotificationChange,
    } = props

    return (
        <React.Fragment>
            <div className="page-border-box2 mb-3 mb-md-4 customer-order-notifications">
                <div className="pbb2-inner d-flex">
                    {/* text-sec */}
                    <div className="text-sec media-body pe-3">
                        {/* header */}
                        <div className="app-header-wrapper heading-sm mb-2">
                            <p className="app-heading st-fw-600 text-capitalize mb-2">Admin notifications</p>
                            <p className="app-desc st-fs-14">
                                These email notifications keep you updated on the important store and customer activities. You can customize any email to make it more suitable for your purposes and include necessary information. You can upload and change the logo, edit the email subject, content, and layout.
                            </p>
                        </div>

                        <div className="customer-order-notifications-list">
                            {
                                loading ? (
                                    <React.Fragment>
                                        {
                                            loadingCount?.map(item => (
                                                <SkeletonLoading key={item} />
                                            ))
                                        }
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        {
                                            notificationsList?.length ? notificationsList?.map(item => (
                                                <NotificationItem
                                                    key={item.template_id}
                                                    dataItem={item}

                                                    handleNotificationClick={(ev, tempId) => handleNotificationClick(ev, tempId)}
                                                    handleNotificationChange={(ev, tempId) => handleNotificationChange(ev, tempId)}
                                                />
                                            )) : (
                                                <p>No notification(s) found</p>
                                            )
                                        }
                                    </React.Fragment>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>

            {/* copy of customer notifications */}
            <CopyOfCustomerNotifications
                loading={loading}
                notificationsData={notificationsData}
                setNotificationsData={setNotificationsData}
            />

            {/* admin email addresses */}
            <AdminEmailAddresses
                loading={loading}
                notificationsData={notificationsData}
                setNotificationsData={setNotificationsData}
            />
        </React.Fragment>
    )
}
